import React, { Component }  from 'react';
import InternalService from '../../services/internal-api';
import './iconography.css';

export default class Iconography extends Component {

  data_service = new InternalService();

  state = {
    saintsFrequency: null
  };

  componentDidMount() {
    this.data_service.getIconography()
        .then((body) => {
          this.setState({
            saintsFrequency: body.data
          });
        });
  }
 
  calculateCellColor(value) {
    const density = Math.min(value / 60, 1); 
    const baseColor = '#00bc8c';
  
    const hexToRgb = (hex) => {
      const bigint = parseInt(hex.replace('#', ''), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `${r}, ${g}, ${b}`;
    };
  
    const rgbColor = hexToRgb(baseColor);
    return `rgba(${rgbColor}, ${density})`;
  }

  renderItems(data) {
    const dateRanges = ['1001-1050', '1051-1100', '1101-1150', '1151-1200', '1201-1250'];

    return (
      <table className="iconography-table">
        <thead>
          <tr>
            <th></th>
            <th></th>
            {dateRanges.map((range) => (
              <th key={range} className="text-center">{range}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.saint}>
              <td className="td_icon">
              {row.random_image_id && (
                <img
                  className="small_icon"
                  src={`${this.data_service._apiBase}saint_images/${row.random_image_id}.jpg`}
                  alt=""
                />
              )}  
              </td>
              <td className="td_name">
                <a href={`../saint/${row.saint_id}`}>{row.saint}</a>
              </td>
              {dateRanges.map((range) => (
                <td 
                  className="td_density"
                  key={`${row.saint}-${range}`}
                  style={{
                    backgroundColor: this.calculateCellColor(row[range]),
                    textAlign: 'center',
                  }}
                >
                  {row[range] == 0 ? '' : row[range]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    const { saintsFrequency } = this.state;

    if (!saintsFrequency) {
      return <div>Loading...</div>;
    }

    const items = this.renderItems(saintsFrequency);

    return (
      <div className="footer-widget-heading padding-both">
        <h3>Iconography</h3>
        <div className="bottom">
          <div className="">{items}</div>
        </div>
      </div>
    );
  }
}